import FormatService from "services/formatService";
import { LOW_MARGIN_THRESHOLD } from "../PricingByClient/PricingByClientConst";

const ALL_CLIENTS_LABEL = "All Clients";

/**
 * Builds the pricing matrix from API data for the "by activity" view.
 * Rows are clients, columns are lots.
 * Returns { rows, lotIdsFromData }.
 */
export const buildActivityPricingMatrixData = ({
    activityPricing,
    selectedLotIds,
    clientLookup,
    vendorLookup,
}) => {
    if (!Array.isArray(activityPricing) || activityPricing.length === 0) {
        return { rows: [], lotIdsFromData: new Set() };
    }

    const hasLotFilter = selectedLotIds?.length > 0;
    const clientMap = {};
    const lotIdsFromData = new Set();

    activityPricing.forEach((pricing) => {
        if (!pricing || pricing.lotId === undefined || pricing.clientId === undefined) {
            return;
        }

        if (hasLotFilter && !selectedLotIds.includes(pricing.lotId)) {
            return;
        }

        lotIdsFromData.add(pricing.lotId);

        const clientKey = pricing.clientId;
        if (!clientMap[clientKey]) {
            clientMap[clientKey] = {
                id: clientKey,
                clientId: clientKey,
                clientLabel: clientLookup?.[clientKey]?.name ?? (clientKey === 0 ? ALL_CLIENTS_LABEL : String(clientKey)),
            };
        }

        const lotKey = `lot_${pricing.lotId}`;
        if (!clientMap[clientKey][lotKey]) {
            clientMap[clientKey][lotKey] = {
                ...pricing,
                formattedCharge: FormatService.formatCurrency(pricing.charge),
                isPMFVendor: vendorLookup?.[pricing.preferredVendorId]?.name === "PMF",
                priceVariance:
                    pricing.priceVarianceData?.sameClientOtherLots?.length > 0 ||
                    pricing.priceVarianceData?.otherClientsSameLot?.length > 0,
                margin: pricing.margin ?? null,
            };
        }
    });

    const rows = Object.values(clientMap).sort((a, b) =>
        a.clientLabel.localeCompare(b.clientLabel)
    );

    return { rows, lotIdsFromData };
};
